module.exports = __webpack_public_path__ + "4142342468d2c5f109a59a092ee91601.png";